module.exports = __webpack_public_path__ + "img/54.ea16a700.jpg";